<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />

    <!-- Container geral com a mesma aparência física de card elevado -->
    <div class="tabela-mandatos" v-if="cargosColegiadosFormat && cargosColegiadosFormat.length !== 0">
      <div class="tabela-mandatos__scroll">
        <table class="table">
          <colgroup>
            <col class="col-nome" />
          </colgroup>
          <thead>
            <tr>          
              <th class="th-nome">Nome</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(cargoColegiado, index) in cargosColegiadosFormat">
              <template>
                <tr :key="cargoColegiado.id" :class="[classesDeEstilo[index], 'linha-clicavel']" @click="irParaDetalhes(cargoColegiado.id)">
                  <td data-label="Nome:" class="td-nome">
                    <span>{{ cargoColegiado.nome }}</span>

                    <!-- Novo Modal de Exclusão Padrão mantido exatamente com sua lógica de visibilidade por style e ID -->
                    <div class="modal-exclusao" :id="cargoColegiado.id" @click.stop>
                      <div class="modal-mask">
                        <div class="modal-container">
                          <div class="modal-header">
                            <h2>Deseja mesmo excluir esse Cargo Colegiado?</h2>
                          </div>
                          <div class="modal-body">
                            <div class="caixa-dados-exclusao">
                              <p class="titulo-dados">Dados do Cargo:</p>
                              <div class="linha-dados-grid">
                                <div class="item-dado item-full">
                                  <strong>Nome:</strong> <span>{{ cargoColegiado.nome }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer footer-organizado">
                            <button class="btn-confirmar-exclusao" @click.stop="excluirLinha(cargoColegiado.id)">Sim</button>
                            <button class="btn-cancelar-exclusao" @click.stop="opcoesExcluir(cargoColegiado.id)">Não</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Estado de tabela vazia unificado ao padrão -->
    <div class="tabela-mandatos tabela-mandatos--vazia" v-else>
      <p class="sem-resultados">Nenhum Resultado Encontrado</p>
    </div>
  </div>
</template>

<script>
import {parseISO, format} from "date-fns"
import MsgErroFormularios from "../MsgErroFormularios";
import CargoColegiadoApi from "../../services/CargoColegiadoApi"

export default {
  name: "TabelaResultadosCargoColegiado",
  props: {
    cargosColegiados: {
      type: Array,
      default: () => []
    }
  },
  created() {
    this.cargoColegiadoApi = new CargoColegiadoApi();
  },
  components: {
    MsgErroFormularios,
  },
  data() {
    return {
      msgErros: {
        cargoColegiado: '',
        default: '',
      },
      erro: false,
      carregando: false,
    };
  },
  computed: {
    cargosColegiadosFormat() {
      return this.cargosColegiados.map((v) => ({ ...v }));
    },
    classesDeEstilo() {
      if (!this.cargosColegiadosFormat || this.cargosColegiadosFormat.length === 0) return [];
      return this.cargosColegiadosFormat.map((_, index) => {
        return index % 2 === 0 ? 'linha-cinza' : '';
      });
    }
  },
  methods: {
    irParaDetalhes(id) {
      this.$router.push({ name: 'CargoColegiadoShow', params: { id: id } });
    },
    opcoesExcluir(cargoColegiadoId) {
      let modalExclusao = document.getElementsByClassName('modal-exclusao')

      for (let i = 0; i < modalExclusao.length; i++) {
        if (modalExclusao[i].id == cargoColegiadoId) {
          if (modalExclusao[i].style.visibility !== "visible") {
            modalExclusao[i].style.visibility = "visible"
          } else {
            modalExclusao[i].style.visibility = "hidden"
          }
        }
      }
    },
    async excluirLinha(cargoColegiadoId) {
      this.opcoesExcluir(cargoColegiadoId)

      try {
        this.carregando = true;
        this.erro = false;

        if (this.cargoColegiadoApi.cancelTokens.destroyCargoColegiado) {
          this.cargoColegiadoApi.cancelTokens.destroyCargoColegiado.cancel();
        }

        await this.cargoColegiadoApi.destroyCargoColegiado(cargoColegiadoId);
        window.location.reload();

      } catch (err) {
        if (this.cargoColegiadoApi.isCancel(err)) {
          return;
        }

        this.carregando = false;
        this.erro = true;

        this.msgErros.cargoColegiado = "Não foi possível excluir o cargo colegiado.";
      }
    },
    formatarData: function(value) {
      if(!value) return '';
      return format(parseISO(value), "dd/MM/yyyy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/TabelaResultadosBase.scss";

/* -------------------------------------------------------------------------- */
/* Tabela de mandatos — Identidade visual SITRA                               */
/* -------------------------------------------------------------------------- */
.tabela-mandatos {
  margin-top: 1.35rem;
  background: #ffffff;
  border: 1px solid #dde5e0;
  border-radius: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 10px 28px rgba(0, 0, 0, 0.08);
  overflow: visible;
}

.tabela-mandatos--vazia {
  padding: 1.75rem 1rem;
  text-align: center;
  overflow: hidden;
  
  .sem-resultados {
    margin: 0;
    color: #5f6f66;
    font-family: "Karla", sans-serif;
    font-size: 0.95rem;
  }
}

.tabela-mandatos__scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  border-radius: 0.85rem;
}

.tabela-mandatos .table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0;
  table-layout: fixed;
}

/* Definição de largura para coluna única */
.tabela-mandatos .col-nome { width: 100%; }

/* Estilos de Célula e Cabeçalho */
.tabela-mandatos .table th,
.tabela-mandatos .table td {
  border: none !important;
  border-bottom: 1px solid #e7eee9 !important;
  padding: 0.75rem 0.85rem;
  vertical-align: middle;
  font-size: 0.95rem; /* Ajustado para 0.95rem */
  color: #1f2d24;
  font-family: "Karla", sans-serif;
  background: transparent;
  border-radius: 0 !important;
}

/* Alinhamento para a esquerda na coluna Nome */
.tabela-mandatos .table .th-nome,
.tabela-mandatos .table .td-nome {
  text-align: left;
  padding-left: 1rem;
}

/* Estilização do cabeçalho com novo padrão de divisórias verticais */
.tabela-mandatos .table thead th {
  background: #ededed !important;
  color: #005516 !important;
  font-family: "Karla", sans-serif;
  font-size: 0.95rem; /* Ajustado para 0.95rem */
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.25;
  border-bottom: 1px solid #d5e2d9 !important;
  
  /* Linha divisória vertical com a cor institucional solicitada */
  border-right: 1px solid #a6c9b1 !important;
  
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
}

/* Remove a borda direita do último th (como é coluna única, impede borda órfã na ponta direita) */
.tabela-mandatos .table thead th:last-child {
  border-right: none !important;
}

/* Efeito Zebrado integrando a classe linha-cinza à paleta institucional */
.tabela-mandatos .table tbody tr {
  transition: background-color 0.15s ease;
  background-color: #ededed; // Define a cor padrão das linhas como #ededed (2ª, 4ª, etc.)
}

/* Primeira linha, terceira linha e assim por diante (que recebem a classe .linha-cinza) ficam brancas */
.tabela-mandatos .table tbody tr.linha-cinza {
  background: #ffffff !important;
}

/* Linha Clicável & Hover com a paleta Verde Institucional */
.linha-clicavel {
  cursor: pointer;
}

.tabela-mandatos .table tbody tr.linha-clicavel:hover {
  background: rgba(0, 85, 22, 0.05) !important;
}

/* -------------------------------------------------------------------------- */
/* Modal de Exclusão (Lógica style.visibility mantida e visual unificado)    */
/* -------------------------------------------------------------------------- */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: table;
  transition: opacity 0.3s ease;
  /* Controlado dinamicamente por style.visibility via JS */

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1001;
    top: 20vh;
    width: calc(40vw - 5rem);
    height: fit-content;
    background-color: #f2f2f2;
    margin: 0 auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }

  .modal-container {
    padding: 1.2rem;
    font-family: "Karla", sans-serif;
    
    .modal-header h2 {
      font-size: 1.2rem;
      font-family: "Karla", sans-serif;
      font-weight: 700;
      color: #1f2d24;
      margin-bottom: 1rem;
    }

    .modal-body {
      border: 1px solid #dde5e0;
      border-radius: 0.75rem;
      background: #ffffff;
      padding: 1rem;
      text-align: left;
      
      .titulo-dados {
        font-family: "Karla", sans-serif;
        font-weight: 700;
        font-size: 0.95rem;
        margin-top: 0;
        margin-bottom: 0.75rem;
        color: #005516;
      }

      .linha-dados-grid {
        font-size: 0.9rem;
        line-height: 1.5;
        
        .item-dado {
          font-family: "Karla", sans-serif;
          font-weight: 700;
          
          span {
            font-family: "Karla", sans-serif;
            font-weight: normal;
            color: #4a5a50;
            margin-left: 0.25rem;
          }
        }
      }
    }
  }

  .modal-footer {
    margin-top: 1rem;
    display: flex;
    justify-content: space-evenly;
    
    button {
      border: none;
      border-radius: 2rem;
      width: 35%;
      height: 2.2rem;
      font-family: "Karla", sans-serif;
      font-weight: 700;
      font-size: 0.9rem;
      cursor: pointer;
      transition: transform 0.1s ease, filter 0.15s ease;
      
      &:hover {
        filter: brightness(0.9);
      }
      
      &:active {
        transform: scale(0.97);
      }
    }

    .btn-confirmar-exclusao {
      background-color: #005516;
      color: #f2f2f2;
    }

    .btn-cancelar-exclusao {
      background-color: #bd0000;
      color: #f2f2f2;
    }
  }
}

/* Responsividade Mobile */
@media screen and (max-width: "768px") {
  .tabela-mandatos .table {
    min-width: 100%; /* Sendo apenas 1 coluna, pode ocupar 100% sem quebrar no mobile */
  }
  .modal-exclusao .modal-mask {
    width: 90% !important;
  }
}
</style>
